
import React, { useEffect, useRef, useState } from "react";
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';
import { AspectRatio, Box, Flex, HStack, Image, Pressable, Skeleton } from "native-base";
import { RFPercentage } from "react-native-responsive-fontsize";
import styles from "./styles";

export default function SkeletonData({ }) {


    return (
        <Flex style={styles.skeletonContainerFlex}>
            <Box width={'100%'}>


                <HStack space="2" style={styles.hStack}>
                    <Skeleton h="3" flex="2" rounded="full" />
                </HStack>

                {[...Array(6)].map((_, rowIndex) => (
                    <Flex key={rowIndex} style={styles.flexitensSketon}>
                        {[...Array(7)].map((_, colIndex) => (
                            <Skeleton key={colIndex}
                                style={styles.itemSkeleton}
                            />
                        ))}
                    </Flex>
                ))}

            </Box>
        </Flex>
    );


}